/**
 * Creates a validator function that checks that the value is equal to a predefined value.
 * @typeparam T The type of the value.
 * @param expectedValue The value that the validated value needs to be.
 */
export const validateIsEqualTo = (expectedValue) => (value, logger, logLabel) => {
    const valid = value === expectedValue;
    if (!valid) {
        logger(`${logLabel} does not match the expected value: ${expectedValue}.`);
    }
    return valid;
};
//# sourceMappingURL=is-equal-to.js.map